"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleWrapText = exports.default = exports.PAGE_SIZE = exports.ColumnMenuAggregates = void 0;
var _clientSideRowModel = require("@ag-grid-community/client-side-row-model");
var _react = require("@ag-grid-community/react");
require("@ag-grid-community/styles/ag-grid.css");
require("@ag-grid-community/styles/ag-theme-alpine.css");
var _columnToolPanel = require("@ag-grid-enterprise/column-tool-panel");
var _core = require("@ag-grid-enterprise/core");
var _menu = require("@ag-grid-enterprise/menu");
var _serverSideRowModel = require("@ag-grid-enterprise/server-side-row-model");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _lodash = require("lodash");
var _react2 = require("react");
var _ = require("../..");
var _hooks = require("../../../hooks");
var _EditEnums = require("../../../types/visualTypes/widgetTypes/EditEnums");
var _utils = require("../../../utils");
var _statusBar = require("@ag-grid-enterprise/status-bar");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_core.LicenseManager.setLicenseKey('Using_this_AG_Grid_Enterprise_key_( AG-049774 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( CGN AND ASSCOCIATES INC )_is_granted_a_( Multiple Applications )_Developer_License_for_( 2 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 4 January 2025 )____[v2]_MTczNTk0ODgwMDAwMA==1cd2a0f431ab8514bb6147afa4b58fc8');
const PAGE_SIZE = exports.PAGE_SIZE = 200;
let ColumnMenuAggregates = exports.ColumnMenuAggregates = /*#__PURE__*/function (ColumnMenuAggregates) {
  ColumnMenuAggregates["Total"] = "Sum";
  ColumnMenuAggregates["Average"] = "Avg";
  ColumnMenuAggregates["Min"] = "Min";
  ColumnMenuAggregates["Max"] = "Max";
  ColumnMenuAggregates["Count"] = "Count";
  return ColumnMenuAggregates;
}({});
//  This is method is used for rowspan
const updateRowSpanData = (data, startRow, spanFields, rowSpanData, blockCounter) => {
  if (spanFields?.length === 0 || data?.length === 0) return;
  spanFields?.forEach(field => {
    let previousValue = null;
    let spanStartRow = startRow;
    data?.forEach((item, index) => {
      const rowIndex = startRow + index;
      let key;
      if (previousValue === item[field]) {
        key = `${field}_${item[field]}_${blockCounter.current}`;
        if (rowSpanData.current[key]) {
          rowSpanData.current[key].end++;
        } else {
          rowSpanData.current[key] = {
            start: spanStartRow,
            end: rowIndex + 1
          };
        }
      } else {
        if (previousValue !== null) {
          const previousKey = `${field}_${previousValue}_${blockCounter.current}`;
          rowSpanData.current[previousKey].end = rowIndex;
          if (rowSpanData.current[previousKey].end - rowSpanData.current[previousKey].start <= 1) {
            delete rowSpanData.current[previousKey];
          }
        }
        previousValue = item[field];
        spanStartRow = rowIndex;
        blockCounter.current++;
        key = `${field}_${item[field]}_${blockCounter.current}`;
        rowSpanData.current[key] = {
          start: rowIndex,
          end: rowIndex + 1
        };
      }
    });
    if (previousValue !== null) {
      const finalKey = `${field}_${previousValue}_${blockCounter.current}`;
      rowSpanData.current[finalKey].end = startRow + data.length;
      if (rowSpanData.current[finalKey].end - rowSpanData.current[finalKey].start <= 1) {
        delete rowSpanData.current[finalKey];
      }
    }
  });
};
const VirtualTable = /*#__PURE__*/(0, _react2.forwardRef)(({
  rows,
  columns,
  highlighted,
  width,
  onRequestRows,
  columnState,
  theme,
  paginationOptions,
  resetOptions,
  isPivotTable,
  paginationMode = 'paginator',
  rowsPerPage = PAGE_SIZE,
  ...rest
}, ref) => {
  const [maxRowSpan, setMaxRowSpan] = (0, _react2.useState)(20);
  const [api, setApi] = (0, _react2.useState)(null);
  const [render, setRender] = (0, _react2.useState)(true);
  const [paginationProperties, setPaginationProperties] = (0, _react2.useState)(paginationOptions);
  const [columnAggregateOptions, setColumnAggregateOptions] = (0, _react2.useState)({});
  const requestAggregates = (0, _react2.useRef)({});
  const [pageSize, setPageSize] = (0, _react2.useState)(rowsPerPage);
  const [tableStatus, setTableStatus] = (0, _react2.useState)('');
  const [wrapText, setWrapText] = (0, _react2.useState)({});

  //That is used for rowspan
  const rowSpanData = (0, _react2.useRef)({});
  const rowSpanBlockCounter = (0, _react2.useRef)(0);
  const createDatasource = () => {
    return {
      getRows: async params => {
        try {
          const gridPageSize = params.request.endRow - params.request.startRow;
          const pageNumber = Math.ceil(params.request.endRow / gridPageSize);
          const response = await onRequestRows(pageNumber, gridPageSize, params.request.sortModel?.length > 0 ? params.request.sortModel : null, !(0, _lodash.isEmpty)(params.request.filterModel) ? params.request.filterModel : null, requestAggregates.current);
          if (response?.rowCount === 0) params.api.showNoRowsOverlay();
          updateRowSpanData(response.rows, params.request.startRow, columns?.filter(col => col.rowSpan).map(col => col.field), rowSpanData, rowSpanBlockCounter);
          let maximumRowSpan = 0;
          Object.keys(rowSpanData.current)?.forEach(key => {
            const rowSpan = rowSpanData.current[key].end - rowSpanData.current[key].start;
            if (rowSpan > maximumRowSpan) {
              maximumRowSpan = rowSpan;
            }
          });
          setMaxRowSpan(maximumRowSpan);
          if (paginationMode === 'infiniteScroll') {
            const {
              rowCount,
              pageCount
            } = response;
            const {
              endRow
            } = params.request;
            setTableStatus(`Showing pages 1 - ${pageNumber} of ${pageCount} pages, 1 - ${endRow >= rowCount ? rowCount : endRow} of ${response.rowCount} rows`);
            params.success({
              rowData: response.rows
            });
          } else params.success({
            rowData: response.rows,
            rowCount: response.rowCount
          });
        } catch (error) {
          console.error(error);
          params.fail();
        }
      }
    };
  };
  const gridRef = (0, _react2.useRef)(null);
  const onPageChange = pageNumber => {
    if (gridRef.current) {
      gridRef.current.api.paginationGoToPage(pageNumber);
      setPaginationProperties({
        ...paginationProperties,
        activePage: pageNumber
      });
    }
  };
  const onPageSizeChanged = value => {
    setPaginationProperties({
      ...paginationProperties,
      pageSize: value
    });
    if (paginationMode === 'paginator') {
      gridRef.current?.api.setGridOption('paginationPageSize', Number(value));
    } else {
      setPageSize(Number(value));
      setTimeout(() => {
        gridRef.current?.api.refreshServerSide();
      }, 500);
    }
  };
  const onGridReady = (0, _react2.useCallback)(params => {
    const {
      api
    } = params;
    setApi(api);
    if (!rows) {
      api.setGridOption('serverSideDatasource', createDatasource());
    }
  }, []);
  function handleFirstDataRendered() {
    if (columnState?.length) return;
    if (!getShouldFlex()) api?.autoSizeAllColumns?.();
  }
  function getShouldFlex() {
    //@ts-ignore
    const tableBody = ref?.current?.getElementsByClassName('ag-body-viewport')[0];
    const tableWidth = tableBody?.clientWidth ?? 0;
    return tableWidth / columns.length > 150;
  }
  const getRowSpan = (params, colName) => {
    if (!params || !params.data) return 1;
    const rowIndex = params.node.rowIndex;
    const dataKey = `${colName}_${params.data[colName]}`;
    for (const key in rowSpanData.current) {
      const spanData = rowSpanData.current[key];
      if (key.startsWith(dataKey) && rowIndex === spanData.start && rowIndex < spanData.end) {
        return spanData.end - rowIndex;
      }
    }
    return 1;
  };
  const columnDefs = (0, _react2.useMemo)(() => {
    if (!api) return [];
    const shouldFlex = getShouldFlex();
    function makeColumn(col, state) {
      const {
        cellRenderer,
        rowSpan,
        dataType,
        field,
        showFilter,
        headerName,
        autoHeight,
        ...rest
      } = col;
      const {
        hide,
        width,
        ...remainingState
      } = state || {};
      setWrapText(prev => ({
        ...prev,
        [headerName]: autoHeight
      }));
      return {
        ...rest,
        ...getFilterParams(showFilter, dataType),
        cellRenderer: cellRenderer ? params => cellRenderer({
          row: params.data,
          column: col,
          rowIndex: params.node.rowIndex,
          node: params.node,
          gridApi: api
        }) : undefined,
        colId: col?.colId ?? headerName,
        headerName,
        headerTooltip: col.headerName,
        hide: hide ?? false,
        rowSpan: rowSpan ? params => getRowSpan(params, field) : undefined,
        cellClassRules: {
          'cell-span': params => {
            return rowSpan ? getRowSpan(params, field) > 1 : false;
          }
        },
        /**
         * If columnState exists but state is undefined, that is a pivot column.
         * setting width to generic pivot column width for such columns
         */
        width: columnState?.length && !state ? 100 : width,
        ...(shouldFlex && {
          flex: width ? undefined : 1
        }),
        ...remainingState,
        field,
        type: dataType,
        autoHeight: wrapText[headerName] || autoHeight,
        cellClass: wrapText[headerName] || autoHeight ? 'ag-custom-cell-wrapper' : ''
      };
    }
    const columnDefs = columns.map(c => {
      const state = columnState?.find(s => s.colId === c.headerName);
      return makeColumn(c, state);
    });
    if (columnState?.length) {
      const sortedColIds = columnState.map(c => c.colId);
      return (0, _lodash.sortBy)(columnDefs, col => {
        /**
         * Sort is based on the index of column in sortedColIds array.
         * sortedColIds array is array of static columns(excluding pivot columns) coming from the columnState in localStorage.
         * All pivot columns should come at the end in the order returned by api.
         * Hence for such columns returning index as 9999 so that they all will be displayed at the end of the table.
         */
        const colIndex = sortedColIds?.indexOf(col.colId);
        if (colIndex == -1) {
          return 9999;
        }
        return colIndex;
      });
    } else {
      return columnDefs;
    }
  }, [api, columns, columnState]);
  (0, _hooks.useUpdateEffect)(() => {
    setRender(false);
    (0, _utils.sleep)(10).then(() => setRender(true));
  }, [rest.suppressColumnVirtualisation]);
  (0, _react2.useEffect)(() => {
    api?.redrawRows();
  }, [highlighted]);
  const getMainMenuItems = (0, _react2.useCallback)(params => {
    const resetItemsIndex = (0, _lodash.indexOf)(params.defaultItems, 'resetColumns');
    const menuItems = params.defaultItems.slice(0);
    if (resetItemsIndex > -1 && resetOptions) {
      menuItems.splice(resetItemsIndex, 1);
      menuItems.push({
        name: 'Reset Columns',
        action: resetOptions
      });
    }
    const {
      type,
      colId
    } = params.column.getColDef();
    if (type && !isPivotTable) {
      menuItems.push({
        name: 'Aggregates',
        subMenu: getSubMenuForAggregateColumn(params, columnAggregateOptions, setColumnAggregateOptions, requestAggregates),
        icon: '<span class="ag-icon ag-icon-aggregation" unselectable="on" role="presentation"></span>'
      });
    }
    menuItems.push({
      name: `${wrapText[colId] ? 'Un-Wrap' : 'Wrap'} Text`,
      action: () => handleWrapText(params, wrapText, setWrapText)
    });
    return menuItems;
  }, [columnAggregateOptions, isPivotTable, wrapText]);
  const gridOptions = {
    alwaysMultiSort: false,
    columnDefs,
    getMainMenuItems: getMainMenuItems,
    defaultColDef: (0, _react2.useMemo)(() => {
      return {
        filter: true,
        cellClass: 'tada-cell',
        wrapHeaderText: true,
        autoHeaderHeight: true
      };
    }, []),
    getContextMenuItems: () => [],
    getRowClass: params => highlighted?.includes(params.node.data?.__index) ? 'ag-row-highlighted' : undefined,
    multiSortKey: 'ctrl',
    onGridReady,
    onFirstDataRendered: handleFirstDataRendered,
    /** Have to add maxRowSpan to fix scrolling bug with rowspans.
     * Large rowBuffer can cause performance issues with large tables.
     * See https://www.ag-grid.com/pipeline/ and search for "rowspan viewport"
     */
    pagination: paginationMode === 'paginator',
    paginationPageSize: pageSize,
    rowBuffer: maxRowSpan ? Math.min(maxRowSpan, 100) : 20,
    rowData: rows,
    rowHeight: 30,
    rowModelType: rows ? 'clientSide' : 'serverSide',
    // Note: 'cacheBlockSize' is not supported with the 'clientSide' row model.
    cacheBlockSize: rows ? null : pageSize,
    statusBar: {
      statusPanels: [{
        statusPanel: 'agTotalRowCountComponent'
      }]
    },
    suppressPaginationPanel: true,
    suppressRowTransform: true,
    ...rest
  };
  const defaultModules = [_menu.MenuModule, _columnToolPanel.ColumnsToolPanelModule, _statusBar.StatusBarModule];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    ref: ref,
    sx: theme_sx => ({
      '.ag-theme-alpine': {
        '--ag-row-hover-color': theme_sx.palette.grayscale.lighter,
        '--ag-cell-horizontal-padding': theme_sx.spacing(0.5),
        '--ag-odd-row-background-color': '#f7f6ff'
      },
      '.ag-theme-alpine-dark': {
        '--ag-odd-row-background-color': '#353e48',
        '--ag-cell-horizontal-padding': theme_sx.spacing(0.5)
      },
      height: 'calc(100% - 40px)',
      width: width || '100%',
      '& .tada-cell': {
        p: 0
      },
      '& .hide-header-label .ag-header-cell-comp-wrapper .ag-header-cell-text': {
        display: 'none'
      },
      '& .ag-row-hover': {
        bgcolor: 'var(--ag-row-hover-color)'
      },
      '& .cell-span': {
        bgcolor: 'var(--ag-background-color)',
        zIndex: '2 !important',
        borderBottom: '1px solid',
        borderBottomColor: 'var(--ag-row-border-color)',
        borderRight: '1px solid !important',
        borderRightColor: 'var(--ag-row-border-color) !important',
        color: theme === 'dark' ? '#ffffff !important' : null
      },
      '.ag-header-cell-label': {
        justifyContent: 'center'
      },
      '.ag-header-cell-label .ag-sort-indicator-container .ag-sort-order': {
        display: 'none'
      },
      '.ag-row-highlighted': {
        background: 'yellow'
      },
      '.ag-theme-alpine-dark .ag-row-highlighted .ag-cell': {
        color: 'black'
      },
      '.ag-custom-cell-wrapper .ag-custom-cell': {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxHeight: '100%'
      },
      '.ag-row-highlighted .ag-cell > .ag-custom-cell': {
        color: `${theme_sx.palette.getContrastText('#FFFF00')}`
      }
    }),
    children: render ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.Paginator, {
        onPageChange: onPageChange,
        onSizeChange: onPageSizeChanged,
        showPageNavigation: paginationMode === 'paginator',
        statusText: tableStatus,
        ...paginationProperties
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.AgGridReact, {
        ref: gridRef,
        className: `ag-theme-alpine${theme === 'dark' ? '-dark' : ''}`,
        modules: [...defaultModules, rows ? _clientSideRowModel.ClientSideRowModelModule : _serverSideRowModel.ServerSideRowModelModule],
        ...gridOptions
      })]
    }) : null
  });
});
const getFilterParams = (show, type) => {
  const filterObject = {
    filter: null,
    filterParams: {
      buttons: ['apply', 'clear'],
      maxNumConditions: 1,
      trimInput: true,
      closeOnApply: true,
      defaultOption: null,
      filterOptions: null
    }
  };
  if (!show) return filterObject;
  switch (type) {
    case _EditEnums.DataType.DATE:
      filterObject.filter = 'agDateColumnFilter';
      filterObject.filterParams.defaultOption = 'inRange';
      filterObject.filterParams.filterOptions = ['inRange'];
      break;
    case _EditEnums.DataType.NUMBER:
      filterObject.filter = 'agNumberColumnFilter';
      filterObject.filterParams.defaultOption = 'contains';
      filterObject.filterParams.filterOptions = ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith'];
      break;
    case _EditEnums.DataType.TEXT:
      filterObject.filter = 'agTextColumnFilter';
      filterObject.filterParams.defaultOption = 'contains';
      filterObject.filterParams.filterOptions = ['contains', 'notContains', 'equals', 'notEqual', 'startsWith', 'endsWith'];
      break;
  }
  return filterObject;
};
/** That is used for custom aggregates menu */
const getSubMenuForAggregateColumn = (params, columnAggregateOptions, setColumnAggregateOptions, requestAggregates) => {
  const column = params.column.getUserProvidedColDef();
  const {
    fieldName,
    colId,
    type,
    showTotal,
    headerName
  } = column;
  let allowedAggregates = [];
  if (type === _EditEnums.DataType.TEXT) {
    allowedAggregates = [ColumnMenuAggregates.Count, ColumnMenuAggregates.Total];
  } else if (type === _EditEnums.DataType.DATE) {
    allowedAggregates = [ColumnMenuAggregates.Count, ColumnMenuAggregates.Min, ColumnMenuAggregates.Max];
  } else if (type === _EditEnums.DataType.NUMBER) {
    allowedAggregates = [ColumnMenuAggregates.Count, ColumnMenuAggregates.Min, ColumnMenuAggregates.Max, ColumnMenuAggregates.Total, ColumnMenuAggregates.Average];
  }
  const getDisplayName = aggregateType => {
    // TypeScript does not support reverse mapping for string enums.
    // Manual implementation required for converting string values to enum members.
    switch (aggregateType) {
      case ColumnMenuAggregates.Average:
        return 'Average';
      case ColumnMenuAggregates.Total:
        return 'Total';
      default:
        return ColumnMenuAggregates[aggregateType];
    }
  };
  return Object.values(ColumnMenuAggregates)?.filter(aggregateType => allowedAggregates.includes(aggregateType))?.map(aggregateType => ({
    name: getDisplayName(aggregateType),
    checked: columnAggregateOptions[colId]?.[aggregateType] || false,
    disabled: aggregateType === ColumnMenuAggregates.Total && showTotal || false,
    action: () => {
      const value = !(columnAggregateOptions[colId]?.[aggregateType] || false);
      setColumnAggregateOptions(prevStates => ({
        ...prevStates,
        [colId]: {
          ...prevStates[colId],
          [aggregateType]: value
        }
      }));
      if (value) {
        requestAggregates.current[`${headerName}_${aggregateType}`] = `${aggregateType}(${headerName})`;
      } else {
        delete requestAggregates.current[`${headerName}_${aggregateType}`];
      }
      params?.api?.refreshServerSide({
        purge: true
      });
    }
  }));
};
const handleWrapText = (params, wrapText, setWrapText) => {
  const {
    column,
    api
  } = params;
  const columnId = column.getColId();
  const columnDefs = api.getColumnDefs();
  const isColumnWrapped = wrapText[columnId];
  const updatedColumnWrapState = {
    ...wrapText,
    [columnId]: !isColumnWrapped
  };
  const updatedColumnDefs = columnDefs?.map(colDef => {
    if (colDef?.field === columnId) {
      const cellClass = !isColumnWrapped ? 'ag-custom-cell-wrapper' : '';
      return {
        ...colDef,
        autoHeight: !isColumnWrapped,
        cellClass
      };
    }
    return colDef;
  });
  api?.setColumnDefs(updatedColumnDefs);
  api?.redrawRows();
  setWrapText(updatedColumnWrapState);
};
exports.handleWrapText = handleWrapText;
var _default = exports.default = VirtualTable;